"use client";
import { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { Layout } from "@/components/Layout/Layout";
import { LeadershipCard } from "@/components/LeadershipCard/LeadershipCard";
import { HeroHeader } from "@/components/HeroHeader/HeroHeader";
import { Heading } from "@/components/Heading/Heading";
import HTMLReactParser from "html-react-parser";
import { getImageSrc } from "@/app/utils/getImageSrc";
import { FaPlay } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

export default function Wrapper({ pageData }) {
    const [isOpen, setOpen] = useState(false);
    return (
        <Layout lightHeader={false}>
            <HeroHeader
                heading={HTMLReactParser(pageData.banner.title)}
                subHeading={HTMLReactParser(pageData.banner.text)}
            />

            <section className="py-16 bg-blue">
                <div className="hp-container flex flex-col items-center">
                    <div className="text-center flex flex-col mb-5 2xl:max-w-[60%] ">
                        <Heading>Leadership</Heading>
                    </div>
                    <div className="flex gap-8 py-8 w-full justify-center">
                        {pageData.leadership.members.map((member, key) => {
                            return (
                                <div
                                    className="flex flex-col items-center justify-center gap-5 w-full md:w-[30.33%]"
                                    key={key}
                                >
                                    <LeadershipCard
                                        name={member.title}
                                        designation={member.designation}
                                        excerpt={member.intro}
                                        alt={member.image?.alt || member.title}
                                        imageSrc={getImageSrc(member.image.url)}
                                        linkedin={false}
                                        slug={member.slug}
                                    />
                                    {member.profile ? (
                                        <Link
                                            href={getImageSrc(
                                                member.profile.url
                                            )}
                                            className="bg-primary border-primary text-white  py-2.5 px-12 rounded-[20px] font-medium text-[18px]  border cursor-pointer flex items-center gap-4"
                                        >
                                            <span>Download Profile</span>{" "}
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth={1.5}
                                                stroke="currentColor"
                                                className="size-6"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
                                                />
                                            </svg>
                                        </Link>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                    <div className="text-center flex flex-col gap-2 max-w-[80%] 2xl:max-w-[60%] mt-12">
                        <Heading>
                            {HTMLReactParser(pageData.manuals.title)}
                        </Heading>
                    </div>
                    <div className="flex flex-col md:flex-row gap-8 py-8 w-full md:w-auto ">
                        {pageData.manuals.blocks.map((manual, key) => {
                            return (
                                <div
                                    className="flex flex-col items-center justify-center gap-5 w-full md:w-auto"
                                    key={key}
                                >
                                    <div className="bg-white rounded-[20px] px-8 py-12 flex flex-col items-center justify-center w-full lg:w-auto">
                                        <Image
                                            alt={manual.image?.alt || manual.title}
                                            src={getImageSrc(manual.image.url)}
                                            width={280}
                                            height={140}
                                            unoptimized
                                            className="h-[70px] w-[200px] lg:w-[280px] object-contain"
                                        />
                                        <h5 className="text-[24px] font-medium">
                                            {manual.title}
                                        </h5>
                                    </div>
                                    <Link
                                        href={getImageSrc(manual.doc.url)}
                                        className="bg-primary border-primary text-white  py-2.5 px-12 rounded-[20px] font-medium text-[14px] lg:text-[16px] xl:text-[18px]  border cursor-pointer flex items-center gap-4"
                                    >
                                        <span>Download Now</span>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth={1.5}
                                            stroke="currentColor"
                                            className="w-5 h-5"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
                                            />
                                        </svg>
                                    </Link>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            <section className="py-16">
                <div className="hp-container flex flex-col items-center">
                    <div className="text-center flex flex-col mb-5 2xl:max-w-[60%] ">
                        <Heading>Corporate Video</Heading>
                    </div>
                    <div className="relative w-full">
                        <div className="relative md:w-[50%] mx-auto h-[400px] flex justify-center items-center">
                            <Image
                                alt={pageData.video.fallbackImage.alt || "Hindustan Power corporate video"}
                                src={getImageSrc(
                                    pageData.video.fallbackImage.url
                                )}
                                width={100}
                                height={80}
                                unoptimized
                                className="w-full h-full object-cover object-top absolute top-0 left-0 rounded-[10px]"
                            />
                            <span
                                className="flex h-12 w-12 cursor-pointer relative"
                                onClick={() => {
                                    setOpen(true);
                                }}
                            >
                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red opacity-75"></span>
                                <span className="relative flex justify-center items-center rounded-full h-12 w-12 bg-red">
                                    <FaPlay className="text-white w-7 h-7 ml-1" />
                                </span>
                            </span>
                        </div>
                    </div>
                    {isOpen ? (
                        <div className="top-0 left-0 fixed w-full h-full bg-black/90 z-[1000] flex justify-center items-center">
                            <IoClose
                                className="absolute right-5 top-5 text-white w-10 h-10 cursor-pointer"
                                onClick={() => {
                                    setOpen(false);
                                }}
                            />
                            <video
                                autoPlay
                                loop
                                controls
                                className="w-auto h-auto object-contain max-w-[90%] lg:max-w-[70%] py-12 mx-auto"
                            >
                                <source
                                    src={getImageSrc(pageData.video.video.url)}
                                    type="video/mp4"
                                />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    ) : null}
                </div>
            </section>
        </Layout>
    );
}
